export default __webpack_public_path__ + "static/media/home-asset-loop.0ef03af1.mp4";